<!--
  创建时间：2024/8/23 17:30
  创建人：toyehuang
  文件描述：BusinessGroup 集团及权属企业
-->

<template>
  <div class="friendly-link mt-20">
    <block-head
      title="集团及权属企业"
      subtitle="/ 优质企业 合作共赢"
      icon="link"
      hid-more-btn
      :more-btn-url="moreUrl"
      :default-active-type="activeCode"
      @change="(code) => (activeCode = code)"
    />
    <div ref="cardLinkListContainer" class="card-link-list-box">
      <!-- <div id="my-slider" class="my-slider swiper-container card-link-list">
        <div class="swiper-wrapper">
          <div
            v-for="link in linkList"
            :key="link.id"
            class="swiper-slide card-link-item"
          >
            <Link :to="link.url || ''" :title="link.name" class="flex-center">
              <img :src="link.image" :alt="link.name" />
              <p>{{ link.name }}</p>
            </Link>
          </div>
        </div>
      </div> -->
      <superslide
        :options="options"
        class="slideBox card-link-list"
        v-if="linkList.length > 0"
      >
        <!-- slides -->
        <div class="bd">
          <ul class="card-link-list">
            <div v-for="link in linkList" :key="link.id" class="card-link-item">
              <Link :to="link.url || ''" :title="link.name" class="flex-center">
                <img :src="link.image" :alt="link.name" />
                <p>{{ link.name }}</p>
              </Link>
            </div>
          </ul>
        </div>
        <!-- slot="prev" -->
        <a class="prev" href="javascript:void(0)" slot="prev"></a>
        <!-- slot="next" -->
        <a class="next" href="javascript:void(0)" slot="next"></a>
      </superslide>
    </div>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import linkApi from "@/api/link";
import {
  getConstantDic,
  LINK_TYPE2,
  SELECT_OPTION_CONFIG,
} from "@/utils/constant";
import BlockHead from "@/views/home/components/BlockHead.vue";

export default {
  name: "BusinessGroup",
  components: { BlockHead, Link },
  props: {},
  data() {
    return {
      activeCode: LINK_TYPE2.LINK_QSQY[SELECT_OPTION_CONFIG.CODE],
      linkList: [],
      options: {
        mainCell: ".bd ul",
        autoPlay: true,
        effect: "leftMarquee",
        vis: 6,
        trigger: "click",
        interTime: 50,
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {
    friendlyLinks() {
      return getConstantDic(LINK_TYPE2);
    },
    moreUrl() {
      return "/friendlyLink/list/" + this.activeCode;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getListData();
  },
  // 方法集合
  methods: {
    getListData() {
      const linkCodes = this.friendlyLinks.map(
        (item) => item[SELECT_OPTION_CONFIG.CODE]
      );
      linkApi.list({ type: linkCodes[0] }).then((res) => {
        this.linkList = res.data || [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
.friendly-link {
  .card-link-list-box {
    width: 100%;
    height: 120px;
    border: 1px solid #eee;
    margin-top: 20px;
    overflow: hidden;
    .card-link-list {
      height: 120px;
      display: flex;
      .card-link-item {
        flex-shrink: 0;
        width: 228px !important;
        height: 100%;
        padding: 0 30px;
        a {
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          font-size: 0;
          text-align: center;
          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
          p {
            line-height: 17px;
            font-size: 14px;
            height: 34px;
            overflow: hidden;
            color: #333;
          }
          &:hover p {
            color: $--color-primary;
          }
        }
        &:not(:last-child):after {
          content: "";
          display: block;
          width: 1px;
          height: 25px;
          background-color: #eee;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(50%, -50%);
        }
      }
    }
  }
}
.slideBox {
  position: relative;
}
.slideBox .prev,
.slideBox .next {
  position: absolute;
  display: none;
  width: 26px;
  height: 51px;
}
.slideBox:hover .prev,
.slideBox:hover .next {
  display: block;
}
.slideBox .prev {
  background: url("../../../assets/images/home/right_icon.png");
  right: 0;
  top: 35px;
  z-index: 99999;
}
.slideBox .next {
  background: url("../../../assets/images/home/left_icon.png");
  left: 0;
  top: 35px;
  z-index: 99999;
}
</style>
